import { SR_API_ACTION_HOUSEHOLD_APPLICATION_SHOULD_GO_TO_CHECKOUT } from 'api/actionTypes';

export default async function shouldGoToCheckout(
  { state, apiClient },
  { householdApplicationId, listingId },
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_APPLICATION_SHOULD_GO_TO_CHECKOUT,
    state: state,
    payload: {
      listingId,
      householdApplicationId,
    },
  });
}
